module.exports = __webpack_public_path__ + "static/media/Wakefield-safeguarding-CYP-during-coronavirus-partnership-approach-V6-v2-1.9c831a58.pdf";